/* ==========================================================================
   UBS Robotics — tema davranislari
   Bagimlilik yok. Shopify temasi ve statik onizleme ayni dosyayi kullanir.
   Sepet islemleri Shopify'in /cart AJAX API'sine gider; onizlemede
   window.UBS_PREVIEW === true oldugunda bu cagrilar atlanir.
   ========================================================================== */
(function () {
  'use strict';

  var PREVIEW = window.UBS_PREVIEW === true;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* --- Mobil cekmece ----------------------------------------------------- */
  function initDrawer() {
    var drawer  = $('[data-drawer]');
    var overlay = $('[data-overlay]');
    if (!drawer || !overlay) return;
    var lastFocus = null;

    function setOpen(open) {
      drawer.setAttribute('data-open', String(open));
      overlay.setAttribute('data-open', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      if (open) {
        lastFocus = document.activeElement;
        var first = drawer.querySelector('button, a, input');
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    $$('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(drawer.getAttribute('data-open') !== 'true'); });
    });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    overlay.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false);
    });

    // Cekmece icindeki akordeonlar
    $$('.drawer__group > button', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* --- Mega menu klavye erisimi ------------------------------------------ */
  function initNav() {
    $$('.nav__item').forEach(function (item) {
      var link = $('.nav__link', item);
      var mega = $('.mega', item);
      if (!link || !mega) return;
      link.setAttribute('aria-expanded', 'false');
      item.addEventListener('focusin', function () { link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('focusout', function () {
        if (!item.contains(document.activeElement)) link.setAttribute('aria-expanded', 'false');
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { link.setAttribute('aria-expanded', 'false'); link.focus(); }
      });
    });
  }

  /* --- Sekmeler ---------------------------------------------------------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var btns   = $$('[role="tab"]', root);
      var panels = $$('[role="tabpanel"]', root);
      function select(i) {
        btns.forEach(function (b, j) {
          b.setAttribute('aria-selected', String(i === j));
          b.tabIndex = i === j ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + btns.length) % btns.length;
          btns[n].focus(); select(n);
        });
      });
      select(0);
    });
  }

  /* --- Adet secici ------------------------------------------------------- */
  function initQty() {
    $$('[data-qty]').forEach(function (root) {
      var input = $('input', root);
      if (!input) return;
      $$('button', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var min  = parseInt(input.min, 10) || 1;
          var max  = parseInt(input.max, 10) || Infinity;
          var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + step));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --- Urun galerisi ----------------------------------------------------- *
   * Gezinme: ok dugmeleri, parmakla kaydirma, klavye ok tuslari, kucuk
   * resimler ve ana gorsele tiklama. Basa/sona gelince basa doner.
   *
   * NOT: eskiden yalnizca kucuk resim tiklamasi vardi; ana gorselde ok
   * yoktu, kaydirma yoktu, ana gorsele tiklamak hicbir sey yapmiyordu -
   * "fotograflar gecilmiyor" sikayeti bundandi.
   * ---------------------------------------------------------------------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (root) {
      var main   = $('[data-gallery-main]', root);
      var thumbs = $$('[data-gallery-thumb]', root);
      if (!main || !thumbs.length) return;

      var sayac = $('[data-gallery-count]', root);
      var indeks = 0;

      function goster(yeni, odakla) {
        if (thumbs.length === 0) return;
        // Basa/sona sarma: -1 -> son, son+1 -> 0
        indeks = ((yeni % thumbs.length) + thumbs.length) % thumbs.length;
        var t = thumbs[indeks];
        var img = $('img', t);
        var full = t.getAttribute('data-full') || (img && img.src);
        if (!full || main.src === full) {
          // src ayni olsa bile isaretlemeyi guncelle
        } else {
          main.classList.add('is-degisiyor');
          main.src = full;
          main.alt = (img && img.alt) || '';
        }
        thumbs.forEach(function (o, i) { o.setAttribute('aria-current', String(i === indeks)); });
        if (sayac) sayac.textContent = (indeks + 1) + ' / ' + thumbs.length;
        if (odakla && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      main.addEventListener('load', function () { main.classList.remove('is-degisiyor'); });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { goster(i); });
      });

      var prev = $('[data-gallery-prev]', root);
      var next = $('[data-gallery-next]', root);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); goster(indeks - 1, true); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); goster(indeks + 1, true); });

      // Ana gorsele tiklamak bir sonrakine gecirir
      main.addEventListener('click', function () { goster(indeks + 1, true); });

      // Klavye: galeri odaktayken sag/sol
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goster(indeks - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goster(indeks + 1, true); }
      });

      // Parmakla kaydirma. Dikey kaydirmayi engellememek icin yatay
      // hareket dikeyden belirgin sekilde buyuk olmali.
      var basX = 0, basY = 0, izliyor = false;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { izliyor = false; return; }
        basX = e.touches[0].clientX; basY = e.touches[0].clientY; izliyor = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!izliyor) return;
        izliyor = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - basX, dy = t.clientY - basY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        goster(dx < 0 ? indeks + 1 : indeks - 1, true);
      }, { passive: true });

      goster(0);
    });
  }

  /* --- Varyant secimi ---------------------------------------------------- */
  function initVariants() {
    var form = $('[data-product-form]');
    if (!form) return;

    var dataEl = $('[data-variant-json]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var idInput  = $('[name="id"]', form);
    var priceEl  = $('[data-variant-price]');
    var cmpEl    = $('[data-variant-compare]');
    var skuEl    = $('[data-variant-sku]');
    var stockEl  = $('[data-variant-stock]');
    var addBtn   = $('[data-add-to-cart]', form);

    function selected() {
      return $$('[data-option-index]', form).map(function (group) {
        var checked = $('[aria-checked="true"]', group) || $('input:checked', group);
        return checked ? (checked.getAttribute('data-value') || checked.value) : null;
      });
    }

    function match(opts) {
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];
    }

    var usdEl = $('[data-usd-ref]');

    /* USD referansi: TL fiyat / TCMB kuru. Varyant degisince yeniden
       hesaplanir - urun metafield'i kullanilsaydi fiyati varyanta gore
       degisen urunlerde (kayislar) tek bir deger yanlis olurdu.
       Bicim Turkce: binlik ".", ondalik ",". */
    function usdBicim(sayi) {
      var tam = Math.floor(sayi);
      var kurus = Math.round((sayi - tam) * 100);
      if (kurus >= 100) { tam += 1; kurus = 0; }
      var tamMetin = String(tam).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '$' + tamMetin + ',' + (kurus < 10 ? '0' : '') + kurus;
    }

    function usdGuncelle(kurusFiyat) {
      if (!usdEl) return;
      var kur = parseFloat(usdEl.getAttribute('data-usd-kur'));
      if (!kur || !isFinite(kur) || kur <= 0) return;
      var usd = (kurusFiyat / 100) / kur;
      var sablon = usdEl.getAttribute('data-usd-sablon');
      if (!sablon) {
        // Ilk metni sablona cevir: icindeki $... tutarini yer tutucuyla degistir
        sablon = usdEl.textContent.replace(/\$[\d.,]+/, '{T}');
        usdEl.setAttribute('data-usd-sablon', sablon);
      }
      usdEl.textContent = sablon.replace('{T}', usdBicim(usd));
    }

    function render() {
      var v = match(selected());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (typeof v.price_cents === 'number') usdGuncelle(v.price_cents);
      if (cmpEl)   { cmpEl.textContent = v.compare_at || ''; cmpEl.hidden = !v.compare_at; }
      if (skuEl)   skuEl.textContent = v.sku || '';
      if (stockEl) {
        stockEl.className = 'stock stock--' + v.stock_state;
        stockEl.textContent = v.stock_label;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = addBtn.getAttribute(v.available ? 'data-label-add' : 'data-label-sold') || addBtn.textContent;
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u);
      }
    }

    $$('[data-option-index]', form).forEach(function (group) {
      $$('.swatch', group).forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (sw.getAttribute('data-available') === 'false') return;
          $$('.swatch', group).forEach(function (o) { o.setAttribute('aria-checked', String(o === sw)); });
          render();
        });
      });
      $$('select', group).forEach(function (sel) { sel.addEventListener('change', render); });
    });

    render();
  }

  /* --- Sepete ekleme (Shopify AJAX API) ---------------------------------- */
  function initAddToCart() {
    var form = $('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (PREVIEW) {
        e.preventDefault();
        toast(form.getAttribute('data-preview-msg') || 'Onizleme modu — sepet devre disi.');
        return;
      }
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt($('[name="id"]', form).value, 10),
            quantity: parseInt(($('[name="quantity"]', form) || {}).value || 1, 10)
          }]
        })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Hata');
          toast(form.getAttribute('data-added-msg') || 'Sepete eklendi.');
          return refreshCartCount();
        })
        .catch(function (err) { toast(err.message, 'danger'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
    });
  }

  function refreshCartCount() {
    if (PREVIEW) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { /* sessiz gec */ });
  }

  /* --- Kucuk bildirim ---------------------------------------------------- */
  var toastTimer;
  function toast(msg, kind) {
    var el = $('[data-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:300;' +
        'padding:12px 20px;border-radius:6px;font-weight:600;font-size:14px;' +
        'box-shadow:0 12px 32px rgba(14,17,22,.28);opacity:0;transition:opacity .2s';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.background = kind === 'danger' ? '#b42318' : '#0e1116';
    el.style.color = '#fff';
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.opacity = '0'; }, 3200);
  }

  /* --- Sozlesme onayi -----------------------------------------------------
     Mesafeli satis mevzuati siparis oncesi onay istiyor. Kutu isaretlenmeden
     odeme adimina gecilemez. HTML "required" tek basina yeterli degil:
     bazi tarayicilar gizli/kaydirilmis alanda uyariyi gostermiyor, ayrica
     kendi hata metnimizi Turkce gostermek istiyoruz.                        */
  function initTerms() {
    var kutu = $('[data-terms-check]');
    if (!kutu) return;
    var form  = kutu.closest('form');
    var hata  = $('[data-terms-error]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // Yalnizca odemeye gecerken zorunlu; "sepeti guncelle" engellenmemeli
      var tetik = e.submitter || document.activeElement;
      var odeme = tetik && tetik.name === 'checkout';
      if (!odeme) return;

      if (!kutu.checked) {
        e.preventDefault();
        if (hata) hata.hidden = false;
        kutu.focus();
        kutu.closest('[data-terms]').scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    kutu.addEventListener('change', function () {
      if (kutu.checked && hata) hata.hidden = true;
    });
  }

  /* --- Dil secici --------------------------------------------------------
     Shopify'da bu is 'localization' formuyla yapilir (bkz. sections/header.liquid);
     statik onizlemede secenek degeri dogrudan hedef adres olur.             */
  function initLangSwitch() {
    var sel = $('[data-lang-switch]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      if (sel.value) window.location.href = sel.value;
    });
  }

  /* --- Para birimi secici -------------------------------------------------
     Shopify'da Markets fiyatlari sunucuda cevirir ve sayfa yenilenir.
     Onizlemede ayni davranisi gostermek icin fiyatlar data-try/data-usd
     ile basiliyor; secim localStorage'da saklanip sayfalar arasi korunuyor. */
  var PARA_ANAHTAR = 'ubs-para';

  function paraUygula(kod) {
    $$('[data-money]').forEach(function (el) {
      var v = el.getAttribute(kod === 'USD' ? 'data-usd' : 'data-try');
      if (v) el.textContent = v;
    });
    $$('[data-currency-switch]').forEach(function (s) { s.value = kod; });
    document.documentElement.setAttribute('data-currency', kod);
  }

  function initCurrencySwitch() {
    var kayitli = null;
    try { kayitli = localStorage.getItem(PARA_ANAHTAR); } catch (e) { /* gizli sekme */ }

    // Kayit yoksa sayfanin dilini izle: EN sayfasi USD, TR sayfasi TRY
    if (!kayitli) {
      kayitli = document.documentElement.lang === 'en' ? 'USD' : 'TRY';
    }
    paraUygula(kayitli);

    $$('[data-currency-switch]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        paraUygula(sel.value);
        try { localStorage.setItem(PARA_ANAHTAR, sel.value); } catch (e) { /* yok say */ }
      });
    });
  }

  /* --- Mobilde filtre paneli --------------------------------------------- */
  function initFacets() {
    var btn = $('[data-facets-toggle]');
    var panel = $('[data-facets]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    function sync() {
      if (window.matchMedia('(min-width: 1000px)').matches) { panel.hidden = false; }
      else if (btn.getAttribute('aria-expanded') !== 'true') { panel.hidden = true; }
    }
    window.addEventListener('resize', sync);
    sync();
  }

  /* --- Kaziyiciya karsi korumali e-posta ---------------------------------- */
  /* Adres sayfada tersten ve iki parca halinde duruyor (data-u / data-d);
     birlestirme burada yapiliyor. "@" ve "mailto:" bu dosyada da bitisik
     yazilmiyor — kaynak kodu taranirsa da eslesme cikmasin diye.
     Isaretlemeyi ureten taraf: snippets/eposta.liquid ve deploy/eposta.ps1. */
  function initEposta() {
    var AT     = String.fromCharCode(64);
    var MAILTO = String.fromCharCode(109, 97, 105, 108, 116, 111, 58);

    function ters(s) { return s.split('').reverse().join(''); }

    $$('[data-eposta]').forEach(function (el) {
      if (el.getAttribute('data-cozuldu') === '1') return;

      var u = ters(el.getAttribute('data-u') || '');
      var d = ters(el.getAttribute('data-d') || '');
      if (!u || !d) return;

      var adres = u + AT + d;
      var a = document.createElement('a');
      a.href = MAILTO + adres;
      a.className = 'eposta__bag';
      a.textContent = el.getAttribute('data-etiket') || adres;

      /* noscript fallback'ini temizleyip yerine bagi koy */
      el.textContent = '';
      el.appendChild(a);
      el.setAttribute('data-cozuldu', '1');
    });
  }

  /* --- Baslat ------------------------------------------------------------ */
  function init() {
    initDrawer();
    initNav();
    initTabs();
    initQty();
    initGallery();
    initVariants();
    initAddToCart();
    initFacets();
    initEposta();
    initTerms();
    initLangSwitch();
    initCurrencySwitch();
    refreshCartCount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.UBS = { toast: toast, refreshCartCount: refreshCartCount };
})();
